export default __webpack_public_path__ + "static/media/cam.a402b51e.webp";